<div class="overview__layout">
  <div class="overview__overview">
    <app-permission-sets-overview></app-permission-sets-overview>
  </div>
  <div class="overview__sidepanel">
    <app-permission-sets-sidepanel></app-permission-sets-sidepanel>
  </div>
</div>
